export default "__VITE_ASSET__vKdOC5N9__"